/* eslint-disable camelcase */

export default class ClinicalSearchBoxStructure {
  constructor({
    gender, overall_status, age, category, localisation, search,
  } = {}) {
    this.gender = gender;
    this.status = overall_status;
    this.age = age;
    this.category = category;
    this.localisation = localisation;
    this.freeSearch = search;
  }

  //   gender:
  // label: "Pour"
  // options:
  // femme: "Une femme"
  // homme: "Un homme"
  // _any: "tous"
  getGenderOptions() {
    if (!this.gender?.options) return [];
    const order = ['femme', 'homme', '_any'];
    return Object.entries(this.gender.options).map(([key, value]) => ({
      key: key === '_any' ? 'tous' : key,
      label: value,
      order: order.indexOf(key),
    })).sort((a, b) => a.order - b.order);
  }

  getStatusOptions() {
    if (!this.status?.options) return [];
    const order = ['en-cours', 'a-venir', '_any'];
    return Object.entries(this.status.options).map(([key, value]) => ({
      key: key === '_any' ? 'tous' : key,
      label: value,
      order: order.indexOf(key),
    })).sort((a, b) => a.order - b.order);
  }
}
